import { createSelector } from 'reselect';
import { get, size, some } from 'lodash/fp';

const isFilteredSelector = createSelector(
  get('playerList.filteredGames'),
  get('playerList.filteredTeams'),
  get('playerList.gameStatusFilters'),
  (...args) => some(size, args)
);

export default isFilteredSelector;
